import {observer} from 'mobx-react-lite'
import * as React from 'react'
import tw from 'tailwind-styled-components'
import {Time} from 'yougile-util'
import {DataObjectId, Hub} from 'yougile-model'
import {AvatarGroup} from '@components/common/base/avatar'
import {IconButton} from '@components/common/base/buttons'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {Sticker} from '@extensions/sticker/sticker'
import {UserStickerState} from '@extensions/sticker/views-web/user/user-sticker-state'
import {UserAccess} from '@extensions/user-access'

const TwContainer = tw.div`
  flex
  gap-8
  items-center
  h-32
  px-8
`

const TwText = tw.div`
  cursor-default
  mr-auto
`

export interface ExecutorRowProps {
  text: string
  values: DataObjectId[]
  hub?: Hub
  project?: Hub
}

export const ExecutorRow = observer((props: ExecutorRowProps) => {
  const {text, values, hub, project} = props
  const forceUpdate = useForceUpdate()

  const users = project ? UserAccess.listUsersInProject(project) : []
  const available = users.map(u => u.id)

  useSyncEvent(
    'current',
    {filter: project?.id},
    () => {
      forceUpdate()
    },
    [project?.id]
  )

  const onChoose = (chosen: DataObjectId[]) => {
    if (!hub || !chosen) {
      return
    }

    Sticker.setUsers(hub, chosen, 'chat')
    hub.data ??= {}
    hub.data.assignedBy ??= {}

    const responsibleId = chosen[0]
    if (responsibleId) {
      if (!hub.data.assignedBy[responsibleId]) {
        hub.data.assignedBy = {}
        hub.data.assignedBy[responsibleId] = Time.now()
      }
    } else {
      hub.data.assignedBy = {}
    }
  }

  return (
    <TwContainer>
      <TwText>{text}</TwText>

      <AvatarGroup userIds={values} size={16} />

      <UserStickerState
        users={values}
        projectId={project?.id}
        options={available}
        onChoose={onChoose}
      >
        <IconButton icon={'IconCustomEdit'} color={'secondary'} />
      </UserStickerState>
    </TwContainer>
  )
})
